/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./VIPRDecoratable',
	'./VIPRItemClassSet',
	'./VIPRTuple'
], function(VIPRDecoratable, VIPRItemClassSet, VIPRTuple) {

	// implements ICatDataItem
	class VIPRCatDataItem extends VIPRDecoratable {
		constructor(resultItem, context, content) {
			super({ getDecorationsCallback: resultItem.getDecorations.bind(resultItem) }, context);

			this.resultItem = resultItem;
			this.context = context;
			this.content = content;
			this.dataItemIndex = this.context.index.dataitem;
			this.dataset = this.context.dataset;
			const slot = this.dataset.slots[this.dataItemIndex];
			this.dataItemFormats = [];
			slot.getDataItemList().forEach(dataItem => {
				this.dataItemFormats.push(dataItem.getFormat());
			});
			this.tuples = [];
			this.itemClassSets = [ new VIPRItemClassSet(this.resultItem.getDataItemList(), this.context) ];
			this.viprItemCache = {};
		}

		destroy() {
			this.itemClassSets.forEach((itemClassSet, index) => {
				itemClassSet.destroy();
				delete this.itemClassSets[index];
			});
			this.tuples.forEach((tuple, index) => {
				tuple.destroy();
				delete this.tuples[index];
			});
			for(const key in this.viprItemCache) {
				this.viprItemCache[key].destroy();
				delete this.viprItemCache[key];
			}
			this.tuples = null;
			this.context = null;
			this.itemClassSets = null;
			this.viprItemCache = null;
			this.dataset = null;
		}

		getUniqueName() {}

		postProcessing() {}

		getCaption() {}

		getType() {
			return 'cat';
		}

		getTupleCount() {
			return this.resultItem ? this.resultItem.getRowCount() : 0;
		}

		getTuple(index) {
			if (index < this.getTupleCount() && this.tuples[index] === undefined) {
				this.context.dataset = this.dataset;
				let tuple = this.resultItem.getValue(index);
				this.context.index = {
					dataitem: this.dataItemIndex,
					dataItemFormats: this.dataItemFormats,
					tuple: index,
					itemClassSet: 0
				};

				this.tuples[index] = new VIPRTuple(tuple, this.context, this.content, this.viprItemCache);
			}
			return this.tuples[index];
		}

		getDataWindowStart() {
			return 0;
		}

		getDataWindowEnd() {
			return this.getTupleCount();
		}

		getItemClassSetCount() {
			return this.itemClassSets.length;
		}

		getItemClassSet(index) {
			return this.itemClassSets[index || 0];
		}
	}

	return VIPRCatDataItem;
});